import { useCallback } from "react";
import { useAppDispatch } from "../hooks";
import { locationCrud } from "../slices/locationSlice";

interface LocationCrudProps {
  method: string;
  data: any;
  slug: string | null;
  query: string | null;
}

export const useLocationRequest = () => {
  const dispatch = useAppDispatch();

  const locationRequest = useCallback(async ({ method, data, slug, query }: LocationCrudProps): Promise<any> => {
    const dispatchData = await dispatch(locationCrud({ method, data, slug, query }));
    return dispatchData;
  }, [dispatch]);

  return locationRequest;
};
